import styled from "styled-components";

export const ChartContainer = styled.div`
  minWidth: 320px;
  width: 470px;
  height: 194px;
  position: relative;
  border: solid rgba(0,0,0,0.05);
  border-radius: 10px;
  padding: 1em 0.3em;
  display: flex;
  place-items: center;

  @media (max-width: 1442px) {
    padding: 1em;
    width: 690px;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    padding: 1em;
    height: auto;
    width: 92%;
  }
`;

export const ChartWrapper = styled.div`
  flex: 0 0 50%;
  height: 150px;
  
  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const TotalAudienceWrapper = styled.div`
  flex: 0 0 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;

  @media (max-width: 768px) {
    width: 100%;
  }

  div.title {
    display: flex;
    align-items: center;
    gap: 5px;

    svg {
      width: 20px;
      height: 20px;
      fill: #2dcca7;
    }

    p {
      font-size: 14px;
      font-weight: 700;
    }
  }

  p.total {
    color: gray;
    margin: 0;
  }

  p.number {
    font-weight: bold;
    font-size: 35px;
    margin: 0;
  }

  p.raised {
    width: 95%;
    background: #edfced;
    padding: 1px;
    color: #33906f;
    font-size: 0.9rem;
  }
`;